import { ResourceKey } from "i18next";

export const RelatedTenders: ResourceKey = {
	relatedTendersTitle: "Related tenders",
	callToAction: "Register in seconds to see more relevant tenders",
}